/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService
 */

export const getPaymentsAccountEligibilityRpc = {
  serviceName: 'com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService',
  rpcName: 'getPaymentsAccountEligibility',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAANQ6UkzAketaKxLm8aUi6Z',
  na1Only: false,
  isStreaming: false
};
export const getDefaultPaymentsAccountDetailsRpc = {
  serviceName: 'com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService',
  rpcName: 'getDefaultPaymentsAccountDetails',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADfqNjIJr3xBaKxLm8aUi6Z',
  na1Only: false,
  isStreaming: false
};
export const getPaymentsAccountDetailsRpc = {
  serviceName: 'com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService',
  rpcName: 'getPaymentsAccountDetails',
  auth: 'app',
  fingerprint: 'ywVLRuHSQCPfqNjIJr3xBaKxLm8aUi6Z',
  na1Only: false,
  isStreaming: false
};
export const getDefaultPublishableKeyRpc = {
  serviceName: 'com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService',
  rpcName: 'getDefaultPublishableKey',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAANwvu2AllYWqKxLm8aUi6Z',
  na1Only: false,
  isStreaming: false
};
export const getDefaultActionEligibilityRpc = {
  serviceName: 'com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService',
  rpcName: 'getDefaultActionEligibility',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAqEe_9GX6nRqKxLm8aUi6Z',
  na1Only: false,
  isStreaming: false
};